import { createFileRoute } from '@tanstack/react-router'
import { SectionHeader, useSiteScope } from '../../-section'
import { ProspectTable } from '../-parts'

export const Route = createFileRoute('/_app/$org/$host/outreach/_list/no-reply')({
  component: NoReplyPage,
})

function NoReplyPage() {
  const { org, host, site } = useSiteScope()
  return (
    <>
      <SectionHeader title="No reply" />
      <ProspectTable
        site={site}
        org={org}
        host={host}
        view="no-reply"
        empty={{
          title: 'Nothing unanswered',
          description: `No thread for ${host} has gone quiet.`,
        }}
      />
    </>
  )
}
